import { Component } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { AdminService } from '../../services/admin.service'
import { HttpStatusCode } from '@angular/common/http'

@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.css'],
})
export class AdminLoginComponent {
  isSubmitting = false
  hidePassword = true

  form = new FormGroup({
    username: new FormControl('', [Validators.required, Validators.minLength(2)]),
    password: new FormControl('', [Validators.required, Validators.minLength(4)]),
  })

  constructor(private adminService: AdminService, private router: Router) {}

  login(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched()
      this.adminService.showNotification('Please enter username and password', 4000, 'Close')
      return
    }
    const username = this.form.get('username')?.value?.trim() ?? ''
    const password = this.form.get('password')?.value ?? ''
    this.isSubmitting = true
    this.adminService.login({ username, password }).subscribe({
      next: (res: any) => {
        this.isSubmitting = false
        if (res.status === HttpStatusCode.Ok || res.status === HttpStatusCode.Created) {
          const body = res.body || {}
          // Token from body is sent as Authorization: Bearer <token> on subsequent admin requests; x-admin-key is sent separately from environment
          const token = body.token ?? body.admin_key ?? body.key ?? body.x_admin_key
          if (token) {
            this.adminService.setAdminKey(token)
            this.adminService.showNotification('Logged in', 2000, 'OK')
            this.router.navigate(['/admin/dashboard'])
          } else {
            this.adminService.showNotification('Login response missing token', 4000, 'Close')
          }
        } else {
          this.adminService.showNotification('Login failed', 4000, 'Close')
        }
      },
      error: (err) => {
        this.isSubmitting = false
        this.adminService.showNotification(
          err?.error?.message ?? 'Invalid username or password',
          5000,
          'Close'
        )
      },
    })
  }
}
